import React from 'react';
import SelectField from './../Form/SelectField';

const FormP1T12 = React.memo((props) => {
    return (
        <form action="">
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '40000', label: '40,000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> Customer Treasury Checks</div>
                <div className="description-list p1t12">
                    <div className="label">
                        <div><b>Description:</b></div>
                        <div>Security custom watermark checks.</div>
                    </div>
                    <div><b>Details:</b></div>
                    <ul>
                        <li>8.5"w x 11"h</li>
                        <li>Single page</li>
                        <li>24# MICR Bond with custom watermark</li>
                        <li>2 Perforated lines</li>
                        <li>Printed front with magnetic ink</li>
                        <li>Red consecutive check number Arabic numbering</li>
                        <li>Custom VOID laser detection Pantograph</li>
                    </ul>
                </div>
            </div>
            <div className="in-production">
                <div className="title">Next order:</div>
                <div>Control number {props.checkControl.start} - {props.checkControl.end}</div>
                <div>(40k checks, 20 boxes)</div>
            </div>
        </form>
    );
});

export default FormP1T12;
